<template>
  <section>
    <div>
      <div class="mt-5">
        <!-- <button
          @click="executeAction('newemail')"
          class="btn btn-sm btn-primary mr-2 float-right"
        >
          <i class="mr-1 icon-plus"></i>{{ $t("lang.label.addnewaccount") }}
        </button> -->
        <Tooltip :text="$t('lang.label.deletedtooltipbutton')">
          <button
            @click="executeAction('Fulldelete')"
            :disabled="loadingDeleteTeam || userselecteddata.length == 0"
            class="btn btn-sm btn-danger mr-2"
          >
            <i class="mr-1 icon-remove"></i
            >{{ $t("lang.button.fulldeletecontact") }}
          </button>
        </Tooltip>
        <button
          @click="executeAction('newUser')"
          :disabled="loadingDeleteTeam"
          class="btn btn-sm btn-primary mr-2"
        >
          <i class="mr-1 icon-plus"></i>{{ $t("lang.user.new") }}
        </button>
        <button
          v-if="isAdmin"
          @click="openManagerCalendarEvents"
          class="btn btn-sm btn-outline-primary mr-2"
        >
          <i class="mr-1 icon-calendar"></i>{{ $t("lang.calendar.event_load_events") || "Watch events" }}
        </button>
      </div>
      <h4 class="mt-2">Users</h4>
      <table id="mytable" class="noselect w-100 table table-hover bg-white">
        <thead>
          <tr>
            <th>Select</th>
            <th>User</th>
            <th width="15px"></th>
            <th>Calendar</th>
            <th>Username</th>
          </tr>
        </thead>
        <span
          v-if="loadingDeleteTeam"
          class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
        ></span>
        <tbody v-else>
          <tr
            v-for="(row, key) in filteredUsersList"
            :key="'user-row-' + key"
            class="overflow-auto"
          >
              <td>
                <!-- checkbox -->
                <input
                  v-if="row.user_status_id != 3"
                  :id="row.id"
                  v-model="userselected[row.id]"
                  @change="checkselectedusers"
                  class=""
                  type="checkbox"
                />
              </td>
              <td class="overflowhide">
                <!-- User -->
                <div>
                  <span v-if="row.parent_sales_representative_id">Team</span>
                  {{ row.name }} {{ row.lastname }}
                  <span
                    class="ml-2 cursor-pointer"
                    @click="
                      updateSalesChild(row.parent_sales_representative_id)
                    "
                    v-if="row.parent_sales_representative_id"
                  >
                    <i class="icon-edit text-primary"></i>
                  </span>
                </div>
                <div
                  class="badge text-white"
                  :class="getClassUserStatus(row.user_status_id)"
                >
                  {{ row.user_status_name }}
                </div>
                <div class="badge text-white badge-primary ml-2">
                  {{ row.role_id == '4' ? 'Billing' : row.role_id == '3' ? 'Sales Rep' : 'Team' }}
                </div>
              </td>
              <td>
                <!-- Provider -->
                <span
                  v-if="row.nylas_email_sync_status == '1' && row.provider"
                >
                  <img
                    v-if="row.provider == 'custom'"
                    width="18px"
                    class="mr-2"
                    src="@/assets/images/generic-icon.svg"
                    alt
                  />
                  <img
                    v-if="row.provider == 'gmail'"
                    width="18px"
                    class="mr-2"
                    src="@/assets/images/gmail-new-icon.png"
                    alt
                  />
                  <img
                    v-if="row.provider == 'ews'"
                    width="18px"
                    class="mr-2"
                    src="@/assets/images/outlook-icon.png"
                    alt
                  />
                </span>
              </td>
              <td class="overflowhide">
                <!-- Calendar -->
                <div class="d-flex flex-column">
                  <p
                    v-if="
                      row.nylas_email_sync_status == '1' && row.role_id == 2
                    "
                    class="text-success"
                  >
                    <span>{{ row.nylas_email_sync }}</span>
                  </p>
                  <p v-else class="mt-1">
                    <span v-if="row.referencing_calendar != '0'">
                      <span
                        :class="
                          row.referencig_calendar_sync_status == '1'
                            ? 'badge-success badge text-white'
                            : 'badge-danger badge text-white'
                        "
                        ><i class="icon-link mr-1"></i>Linked to
                        {{ row.referencing_calendar }}</span
                      >
                    </span>
                    <span
                      v-if="
                        row.referencing_calendar == '0' &&
                          row.nylas_calendar_sync_status != '1' &&
                          !row.parent_sales_representative_id &&
                          !row.nylas_calendar_email_sync
                      "
                    >
                      <span class="badge-danger badge text-white"
                        ><i class="icon-unlink mr-1"></i>Not-sync</span
                      >
                    </span>
                    <span
                      v-if="
                        row.referencing_calendar == '0' &&
                          row.nylas_calendar_sync_status == '0' &&
                          row.nylas_calendar_email_sync
                      "
                    >
                      <span class="badge-danger badge text-white"
                        ><i class="icon-unlink mr-1"></i
                        >{{ row.nylas_email_sync }}</span
                      >
                    </span>

                    <span
                      v-if="
                        row.referencing_calendar == '0' &&
                          row.nylas_calendar_sync_status == '1'
                      "
                    >
                      <span
                        class="badge-success badge text-white cursor-pointer"
                        ><i class="icon-mail mr-1"></i>Synced</span
                      >
                    </span>
                  </p>
                  <a
                    :ref="'url_' + row.id"
                    target="_blank"
                    :href="getCalendarLink(row.domaincalendar, row.id)"
                    class="text-primary ml-0"
                    >{{ getCalendarLink(row.domaincalendar, row.id) }}</a
                  >
                  <p class="mt-1">
                    <i
                      class="icon-copy"
                      @click="copyUrl(row.domaincalendar, row.id)"
                    ></i>
                  </p>
                </div>
              </td>
              <td class="overflowhide">
                <!-- Username -->
                <div v-if="!row.parent_sales_representative_id">
                  <a
                    target="_blank"
                    :href="'/users/' + row.id"
                    class="text-primary"
                    >{{ row.email }}</a
                  >
                </div>
                <a
                  v-if="!row.parent_sales_representative_id"
                  :href="
                    '/login?user=' +
                      row.email +
                      '&pass=' +
                      encodeURIComponent('QM!9aT!a^u5&v!Up!wGtHq')
                  "
                  target="_blank"
                  class="badge-primary badge text-white cursor-pointer"
                  >Login
                </a>
              </td>
            </tr>
        </tbody>
      </table>
    </div>

    <modal
      :resizable="true"
      :scrollable="true"
      :max-width="700"
      height="auto"
      width="80%"
      style="z-index: 10"
      class="modal-preview p-4"
      name="clientManagerCalendarEvents"
    >
      <div class="p-4">
        <h5 class="mb-3 font-weight-bold">Manager events</h5>
        <div class="mb-3">
          <h4 class="mb-2">Search events for:</h4>
          <select
            v-model="selectedEventsOptionValue"
            class="form-control"
            :disabled="loadingManagerEvents"
          >
            <option
              v-for="opt in eventsModalSelectOptions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.label }} ( {{ opt.email }} )
            </option>
          </select>
        </div>
        <div class="row align-items-end mb-3">
          <div class="col-md-4">
            <label class="small font-weight-bold text-secondary mb-1">{{ $t("lang.calendar.event_from_date") }}</label>
            <input
              v-model="managerEventsFromDate"
              type="datetime-local"
              class="form-control form-control-sm"
              :disabled="loadingManagerEvents"
            />
          </div>
          <div class="col-md-4">
            <label class="small font-weight-bold text-secondary mb-1">{{ $t("lang.calendar.event_to_date") }}</label>
            <input
              v-model="managerEventsToDate"
              type="datetime-local"
              class="form-control form-control-sm"
              :disabled="loadingManagerEvents"
            />
          </div>
          <div class="col-md-4">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              :disabled="loadingManagerEvents || !selectedEventsOptionValue"
              @click="fetchManagerCalendarEvents"
            >
              <i class="icon-refresh mr-1" v-if="!loadingManagerEvents"></i>
              {{ loadingManagerEvents ? "..." : ($t("lang.calendar.event_load_events") || "Load events") }}
            </button>
          </div>
        </div>
        <LoadingSpinner v-if="loadingManagerEvents" />
        <template v-else>
          <p v-if="!managerCalendarEvents || managerCalendarEvents.length === 0" class="text-secondary mb-0">
            {{ $t("lang.calendar.event_no_events_in_range") }}
          </p>
          <div v-else>
            <CalendarEvent
              v-for="(evt, idx) in managerCalendarEvents"
              :key="evt.id || idx"
              :event="evt"
            />
          </div>
        </template>
        <div class="mt-3 text-right">
          <button type="button" class="btn btn-secondary" @click="closeManagerEventsModal">
            {{ $t("lang.button.close") }}
          </button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import { mapState } from "vuex";
import {
  usersService,
  monitorService,
  adminService,
} from "@/_services";
import Tooltip from "@/components/Common/Tooltip.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import CalendarEvent from "@/components/Calendar/CalendarEvent.vue";

export default {
  data() {
    return {
      loadingDeleteTeam: false,
      userselected: {}, // Cambiar a objeto indexado por ID
      userselecteddata: [],
      usersAction: false,
      list: [],
      filtersDash: {},
      selectedEventsOptionValue: null,
      managerCalendarEvents: [],
      loadingManagerEvents: false,
      managerEventsFromDate: "",
      managerEventsToDate: "",
    };
  },
  props: {
    team_id: String, // esto en realidad es client_id
  },
  created() {
    this.filtersDash.getEmailTeam = false;
    this.filterNow();
  },
  watch: {
    // Limpiar selecciones cuando se refresca la lista
    list: {
      handler() {
        // Limpiar selecciones cuando la lista cambia
        this.userselecteddata = [];
        this.usersAction = "";
      },
      deep: true
    }
  },
  components: {
    Tooltip,
    LoadingSpinner,
    CalendarEvent,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
    isAdmin() {
      return this.currentUser && this.currentUser.role_id === "1";
    },
    filteredUsersList() {
      return this.list.filter(row =>
        !row.parent_sales_representative_id && row.role_id != 2
      );
    },
    eventsModalSelectOptions() {
      const opts = [];
      const seen = new Set();
      this.list.forEach((item) => {
        if (item.id == null || seen.has(item.id) || item.isFake == "1" || item.child_sales_representative_id != null) return;
        seen.add(item.id);
        const name = [item.name, item.lastname].filter(Boolean).join(" ").trim() || "User " + item.id;
        opts.push({
          value: "user_" + item.id,
          label: name,
          email: item.email || "",
          userId: item.id,
          accountId: typeof btoa !== "undefined" ? btoa(String(item.id)) : "",
          useAccountId: true,
        });
      });
      return opts;
    },
  },
  methods: {
    filterNow(filter) {
      this.list = [];
      if (filter != undefined) {
        this.filtersDash = filter;
        this.filtersDash.getGraphData = true;
      }
      monitorService
        .getMonitorList(this.team_id, this.filtersDash)
        .then(result => {
          if (result.length == 0) {
            // Empty result
          } else {
            this.list = result;
            // Limpiar selecciones previas y reinicializar
            const previousSelected = { ...this.userselected };
            this.userselected = {};
            this.userselecteddata = [];
            this.usersAction = "";
            
            this.list.forEach((item, index) => {
              item.user = item.name + ' ' + item.lastname + ' (' + item.id + ')';
              // Restaurar el estado de selección por ID si existía antes
              this.$set(this.userselected, item.id, previousSelected[item.id] || false);
            });
          }
        });
    },
    checkselectedusers() {
      this.userselecteddata = [];
      this.usersAction = "";
      // Iterar sobre la lista filtrada para obtener solo los usuarios visibles
      this.filteredUsersList.forEach((item) => {
        if (this.userselected[item.id]) {
          this.userselecteddata.push(item.id);
          this.usersAction =
            this.usersAction +
            "<br>" +
            item.name +
            " " +
            item.lastname;
        }
      });
    },
    executeAction(type, params) {
      if (type == "newemail") {
        this.$emit("newemail");
        return;
      }

      if (type == "newUser") {
        this.$emit("newUser");
        return;
      }

      if (type == "opencalendar") {
        this.$emit("opencalendar", params);
        return;
      }

      this.$swal({
        type: "warning",
        title: this.$t("lang.refuse.sure"),
        html: this.usersAction,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
        cancelButtonText: this.$t("lang.button.cancel")
      }).then(result => {
        if (result.value) {
          switch (type) {
            case "Fulldelete":
              this.loadingDeleteTeam = true;
              let data = {
                users: this.userselecteddata,
                fullDelete: true
              };
              usersService.deleteUsers(data).then(r => {
                this.$emit("refresh");
                this.loadingDeleteTeam = false;
              });
              break;
          }
        }
      });
    },
    copyUrl(domain, row) {
      const url = this.getCalendarLink(domain, row);
      this.copyToClipboard(url);
    },
    getCalendarLink(domain, id) {
      let sales_id = btoa(id);
      return "https://" + domain + "/calendar/" + sales_id;
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    getClassUserStatus(id) {
      switch (id) {
        case "1":
          return "badge-success";
        case "2":
          return "badge-secondary";
        case "3":
          return "badge-danger";
        case "4":
          return "badge-warning";
      }
    },
    updateSalesChild(from, actualsalesname) {
      this.$emit("updateSalesChild", from, actualsalesname);
    },
    getDefaultEventsFromTo() {
      const now = new Date();
      const from = new Date(now.getTime() - 2 * 60 * 60 * 1000);
      const to = new Date(now.getTime() + 30 * 60 * 60 * 1000);
      return {
        from: this.formatDateTimeLocal(from),
        to: this.formatDateTimeLocal(to),
      };
    },
    formatDateTimeLocal(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${y}-${m}-${day}T${h}:${min}`;
    },
    openManagerCalendarEvents() {
      const opts = this.eventsModalSelectOptions;
      if (!opts || opts.length === 0) {
        this.$swal({
          type: "warning",
          title: "No options",
          text: "No users available to watch events.",
        });
        return;
      }
      this.selectedEventsOptionValue = opts[0].value;
      const defaults = this.getDefaultEventsFromTo();
      this.managerEventsFromDate = defaults.from;
      this.managerEventsToDate = defaults.to;
      this.$modal.show("clientManagerCalendarEvents");
      this.fetchManagerCalendarEvents();
    },
    async fetchManagerCalendarEvents() {
      const opt = this.eventsModalSelectOptions.find((o) => o.value === this.selectedEventsOptionValue);
      if (!opt || opt.userId == null) return;
      const now = new Date();
      const fromDate = this.managerEventsFromDate
        ? new Date(this.managerEventsFromDate)
        : new Date(now.getTime() - 2 * 60 * 60 * 1000);
      const toDate = this.managerEventsToDate
        ? new Date(this.managerEventsToDate)
        : new Date(now.getTime() + 30 * 60 * 60 * 1000);
      const fromTime = fromDate.getTime();
      const toTime = toDate.getTime();
      if (isNaN(fromTime) || isNaN(toTime)) return;
      const hoursBack = Math.round(Math.max(0, (now.getTime() - fromTime) / (1000 * 60 * 60)));
      const hoursForward = Math.round(Math.max(0, (toTime - now.getTime()) / (1000 * 60 * 60)));
      this.loadingManagerEvents = true;
      this.managerCalendarEvents = [];
      const params = {
        hours_back: hoursBack,
        hours_forward: hoursForward,
      };
      if (opt.useAccountId && opt.accountId) {
        params.account_id = opt.accountId;
      } else {
        params.user_id = opt.userId;
      }
      try {
        const result = await adminService.getEventsByRange(params);
        if (result && result.success === false && result.error) {
          this.managerCalendarEvents = [];
          this.$swal({
            type: "error",
            title: "Error loading events",
            text: result.error,
          });
          return;
        }
        this.managerCalendarEvents = Array.isArray(result)
          ? result
          : (result && result.events) || (result && result.data) || [];
      } catch (err) {
        this.managerCalendarEvents = [];
        const errorMsg = (err && err.error) || (err && err.message) || "No events could be loaded.";
        this.$swal({
          type: "error",
          title: "Error",
          text: errorMsg,
        });
      } finally {
        this.loadingManagerEvents = false;
      }
    },
    closeManagerEventsModal() {
      this.$modal.hide("clientManagerCalendarEvents");
    },
  }
};
</script>

<style scoped>
.overflowhide {
  overflow: hidden;
}
</style>
